export default __webpack_public_path__ + "e5bd7c5547d2f05c0c291798f5b8e84c.svg";